<div class="content-container">
  @if (isLoggedIn$()) {
    @let accessState = hasInternalAccessState$();
    @if (accessState.status === 'loading') {
      <div class="spinner-container">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    } @else if (accessState.status === 'error') {
      <p class="no-data">
        The Scenario Explorer is not responding. <br />
        Please try again later.
      </p>
    } @else if (accessState.data === false) {
      <form
        [formGroup]="scenarioAccessForm"
        (ngSubmit)="submitInternalScenarioPassword()"
        class="scenario-form"
      >
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Internal scenario explorer password</mat-label>
          <input matInput formControlName="password" autocomplete="off" />
        </mat-form-field>
        <button matButton="filled" type="submit">Submit</button>
      </form>
    } @else {
      @if (models$() == null) {
        <p class="no-data">
          No scenario available. <br />
          Please, try again later.
        </p>
      } @else {
        <h3>Model</h3>
        <mat-form-field subscriptSizing="dynamic" class="select-form-field">
          <mat-select
            id="model"
            [value]="scenarioExplorerPayload$().model"
            (selectionChange)="onModelChange($event.value)"
          >
            @for (model of availableModels$(); track model) {
              <mat-option [value]="model">{{ model }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <h3>Scenario</h3>
        <mat-form-field subscriptSizing="dynamic" class="select-form-field">
          <mat-select
            id="scenario"
            [value]="scenarioExplorerPayload$().scenario"
            (selectionChange)="onScenarioChange($event.value)"
            [disabled]="!scenarioExplorerPayload$().model"
          >
            @for (scenario of availableScenarios$(); track scenario) {
              <mat-option [value]="scenario">{{ scenario }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <h3 class="definition-title">Definition</h3>

        <!-- Variable -->
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Variable</mat-label>
          <mat-select
            class="mat-select"
            id="variable-select"
            [value]="scenarioExplorerPayload$().variable"
            (selectionChange)="onVariableChange($event.value)"
            [disabled]="!scenarioExplorerPayload$().scenario"
            [matTooltip]="scenarioExplorerPayload$().variable"
            matTooltipPosition="right"
          >
            @for (variable of availableVariables$(); track variable) {
              @if (variable.length > 33) {
                <mat-option [value]="variable" [matTooltip]="variable" matTooltipPosition="right">
                  {{ variable.substring(0, 33) + '...' }}
                </mat-option>
              } @else {
                <mat-option [value]="variable">
                  {{ variable }}
                </mat-option>
              }
            }
          </mat-select>
        </mat-form-field>

        <!-- Region -->
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Region scale</mat-label>
          <mat-select
            class="mat-select"
            id="region-select"
            [value]="scenarioExplorerPayload$().region"
            (selectionChange)="onRegionChange($event.value)"
            [disabled]="!scenarioExplorerPayload$().scenario || availableRegions$().length === 0"
          >
            @for (region of availableRegions$(); track region) {
              <mat-option [value]="region">{{ region }}</mat-option>
            }
          </mat-select>
          <mat-hint
            class="hint"
            [hidden]="!(availableRegions$().length === 0 && scenarioExplorerPayload$().scenario)"
            >No selection needed for this scenario</mat-hint
          >
        </mat-form-field>

        <!-- Year -->
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Year</mat-label>
          <mat-select
            class="mat-select"
            id="year-select"
            [value]="scenarioExplorerPayload$().year"
            (selectionChange)="onYearChange($event.value)"
            [disabled]="!scenarioExplorerPayload$().scenario"
          >
            @for (year of availableYears$(); track year) {
              <mat-option [value]="year">{{ year }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <!-- Subbannual -->
        @if (availableSubannuals$()) {
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Subannual</mat-label>
            <mat-select
              class="mat-select"
              id="subannual-select"
              [value]="scenarioExplorerPayload$().subannual"
              (selectionChange)="onSubannualChange($event.value)"
              [disabled]="!scenarioExplorerPayload$().scenario"
            >
              @for (subannualValue of availableSubannuals$(); track subannualValue) {
                <mat-option [value]="subannualValue">{{ subannualValue }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <button matButton="filled" class="main-button" (click)="getScenarioExplorerResultData()">
          <mat-icon>
            @if (isDataLoading$()) {
              <mat-spinner class="spinner-button" diameter="18"></mat-spinner>
            } @else {
              play_arrow
            }
          </mat-icon>

          Visualize data
        </button>
      }
    }
  } @else {
    <p class="no-data">Scenario explorer requires login and internal access authorization</p>
  }

  @if (scenarioResults$().length > 0) {
    <mat-accordion>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title> Scenario results </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="layers-list">
          @for (result of scenarioResults$(); track $index) {
            <app-card-layer-scenario [result]="result"></app-card-layer-scenario>
          }
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  }
</div>
